import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsProducingOrFinishedProductionResourceAvailable } from "../selectors/selectBuildingsProducingOrFinishedProductionResourceAvailable";
import { createPathFocusBuildingMaxLevel } from "./createPathFocusBuildingMaxLevel";
export var pathFocusPremiumBuildingProductionDoneMaxLevelByResourceId = function (action, state$, deps) {
    return createPathFocusBuildingMaxLevel(function () {
        var state = state$.value;
        var resourceId = action.taskType.resourceId;
        var availableBuildings = selectBuildingsProducingOrFinishedProductionResourceAvailable(state, resourceId);
        return availableBuildings.filter(function (building) {
            return utilBuildings.hasFinishedProduction(building) && utilBuildings.isPremium(building);
        });
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathFocusPremiumBuildingProductionDoneMaxLevelByResourceId.ts
// module id = 2360
// module chunks = 3